import { subclass, property, aliasOf } from "@arcgis/core/core/accessorSupport/decorators";

import Widget from "@arcgis/core/widgets/Widget";
import t9nAppMessages from "../../t9n/App/App.json";

import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import Collection from '@arcgis/core/core/Collection';

import "./FilterChips/FilterChips.scss";
import FilterChipsViewModel from './FilterChips/FilterChipsViewModel';

export type filterType = "capability" | "category";

export interface IChipState {
  guid: string,
  text: string,
  filterType: filterType
};

@subclass("Landing.widgets.FilterChips")
export default class FilterChips extends (Widget) {

  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  viewModel: FilterChipsViewModel = new FilterChipsViewModel();

  @property()
  @aliasOf("viewModel.chips")
  readonly chips: __esri.Collection<IChipState> = new Collection([]);

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  //--------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  //--------------------------------------------------------------------------

  render() {

    return (
      <div class="filter-chips">
        {
          this.chips?.map((chip, index) => { return this._renderChip(chip, index) }).toArray()
        }
      </div>
    );
  }

  //--------------------------------------------------------------------------
  //
  //  Private Methods
  //
  //--------------------------------------------------------------------------
  private _renderChip(chip: IChipState, index: number) {
    return (
      <calcite-chip
        scale="m"
        appearance="solid"
        color="grey"
        dismissible={true}
        afterCreate={(chipDOM: HTMLCalciteChipElement) => {
          chipDOM.addEventListener("calciteChipDismiss", () => {
            this._handleDismiss(this.chips.getItemAt(index));
          });
        }}
      >
        {this.appMessages.filterChips[chip.filterType]}: { chip.text}
      </calcite-chip>
    );
  }

  private _handleDismiss(chipToDismiss: IChipState) {
    const foundChip = this.chips.find(chip => chip.guid === chipToDismiss.guid);
    this.chips.remove(foundChip);
  }

}